module.exports = __webpack_public_path__ + "static/media/yz_m1.95822825.gif";